import { useFavorites } from "@/hooks/useFavorites";

interface FavoriteButtonProps {
  siteId: string;
  variant?: "icon" | "full";
}

export default function FavoriteButton({ siteId, variant = "icon" }: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(siteId);

  if (variant === "full") {
    return (
      <button
        type="button"
        onClick={() => toggleFavorite(siteId)}
        aria-pressed={active}
        className={`flex items-center justify-center gap-2 px-6 py-3 rounded-md border text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
          active
            ? "border-accent-300 bg-accent-100 text-accent-700"
            : "border-background-200 bg-background-50 text-foreground-700 hover:border-accent-300 hover:text-accent-700"
        }`}
      >
        <i className={active ? "ri-heart-fill text-base" : "ri-heart-line text-base"} />
        {active ? "已收藏" : "收藏该网址"}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleFavorite(siteId);
      }}
      aria-pressed={active}
      aria-label={active ? "取消收藏" : "收藏"}
      title={active ? "取消收藏" : "收藏"}
      className={`w-9 h-9 rounded-md flex items-center justify-center border transition-colors cursor-pointer shrink-0 ${
        active
          ? "border-accent-300 bg-accent-100 text-accent-600"
          : "border-background-200 bg-background-50 text-foreground-400 hover:text-accent-600 hover:border-accent-300"
      }`}
    >
      <i className={active ? "ri-heart-fill" : "ri-heart-line"} />
    </button>
  );
}